import React from 'react';
import bodyRegistrationMaskUrl from '../../assets/avatar/avatar-v3-fallback-registration-mask.png';

export const AVATAR_TINT_MASK_RENDER_MODE = 'tint-mask';
export const AVATAR_BODY_REGISTRATION_MASK_URL = bodyRegistrationMaskUrl;
export const AVATAR_BODY_REGISTRATION_BACKING_COLOR = '#2d2019';

export function resolveAvatarTintUrls(part, variant, getImageUrl, fallbackAssets = {}) {
  const inkMediaId = part?.assets?.mediaId;
  const maskMediaId = part?.assets?.tintMaskMediaId;
  return {
    inkUrl: (inkMediaId ? getImageUrl(inkMediaId, variant) : null) || fallbackAssets?.inkUrl || null,
    maskUrl: (maskMediaId ? getImageUrl(maskMediaId, variant) : null) || fallbackAssets?.maskUrl || null,
  };
}

export function isAvatarTintReady({ inkUrl, maskUrl }, swatch) {
  return Boolean(inkUrl && maskUrl && swatch?.value);
}

export default function AvatarTintLayer({
  className = '',
  dataSlot,
  fit = 'contain',
  inkUrl,
  maskUrl,
  position = 'center',
  swatch,
}) {
  if (!isAvatarTintReady({ inkUrl, maskUrl }, swatch)) return null;

  const maskImage = `url("${maskUrl}")`;
  const fillStyle = {
    backgroundColor: swatch.value,
    WebkitMaskImage: maskImage,
    WebkitMaskPosition: position,
    WebkitMaskRepeat: 'no-repeat',
    WebkitMaskSize: fit,
    maskImage,
    maskMode: 'alpha',
    maskPosition: position,
    maskRepeat: 'no-repeat',
    maskSize: fit,
  };
  const usesBodyRegistration = dataSlot === 'body_base';
  const registrationImage = `url("${AVATAR_BODY_REGISTRATION_MASK_URL}")`;
  const registrationStyle = usesBodyRegistration ? {
    backgroundColor: AVATAR_BODY_REGISTRATION_BACKING_COLOR,
    WebkitMaskImage: registrationImage,
    WebkitMaskPosition: position,
    WebkitMaskRepeat: 'no-repeat',
    WebkitMaskSize: fit,
    maskImage: registrationImage,
    maskMode: 'alpha',
    maskPosition: position,
    maskRepeat: 'no-repeat',
    maskSize: fit,
  } : undefined;
  const artwork = (
    <>
      <span className="avatar-tint-layer__fill" data-tint-mask={maskUrl} style={fillStyle} />
      <img
        alt=""
        className="avatar-tint-layer__ink"
        decoding="async"
        draggable="false"
        src={inkUrl}
        style={{ objectFit: fit, objectPosition: position }}
      />
    </>
  );

  return (
    <span
      aria-hidden="true"
      className={`avatar-tint-layer ${className}`.trim()}
      data-render-mode={AVATAR_TINT_MASK_RENDER_MODE}
      data-slot={dataSlot}
      data-swatch={swatch.id}
    >
      {usesBodyRegistration ? (
        <span
          className="avatar-tint-layer__registration"
          data-registration-mask={AVATAR_BODY_REGISTRATION_MASK_URL}
          style={registrationStyle}
        >
          {artwork}
        </span>
      ) : artwork}
    </span>
  );
}
